import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { Platform } from '@ionic/angular';
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewComponent implements OnInit {
  @Input() id_parent: any;
  @Input() left: any;
  @ViewChild('img', { static: true }) image: ElementRef<any>;
  widthImg: any;
  isMobile: any

  constructor(
    public platform: Platform
  ) {
    if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
  }
  ngOnInit(): void {
    // this.widthImg = (this.image.nativeElement.getBoundingClientRect().width);
    // if (this.widthImg > 768) {
    //   this.widthImg = this.widthImg / 2 - 15;
    // }
  }

  img: any = 'assets/img/0801_iot.png'
  title: any = 'Chúng tôi cung cấp những gì?'
  content: any = 'Bằng sự chuyên nghiệp, nghiên cứu chuyên môn, Viethas cung cấp cho khách hàng những sản phẩm về phần mềm (phần mềm bán hàng, phần mềm quản lý hàng hóa, quản lý cà phê - nhà hàng, phần mềm quản lý thu chi,…); các giải pháp công nghệ IoT (hệ thống giám sát năng lượng, giải pháp nông nghiệp thông minh..). Ngoài phân phối thiết bị công nghệ, triển khai lắp đặt, bảo dưỡng, Viethas còn cung cấp các dịch vụ gia công phần cứng IoT, phát triển ứng dụng, thiết kế website, bảo trì hệ thống… nhằm đáp ứng nhu cầu sử dụng đa dạng, giúp giải quyết các vấn đề của khách hàng một cách hiệu quả nhất.'
  img2: any = 'assets/img/overview1.png'
  title2: any = 'Chúng tôi có gì khác biệt?'
  content2: any = 'Viethas chú trọng mang đến các sản phẩm thân thiện với người dùng, dễ dàng sử dụng và tối ưu các tính năng. Chúng tôi luôn lắng nghe các vấn đề và yêu cầu của khách hàng để đưa ra các giải pháp phù hợp, các sản phẩm tốt nhất, đạt chất lượng, đáp ứng nhu cầu của khách hàng và mang lại những những trải nghiệm tốt nhất. Với đội ngũ nhân viên trẻ đầy nhiệt huyết, đam mê, sáng tạo, không ngừng học hỏi, luôn cập nhật để đổi mới, nâng cao kỹ năng chuyên môn nhằm đáp ứng nhu cầu công nghệ không ngừng thay đổi và phát triển.'
  img3: any = 'assets/img/overview2.png'
  title3: any = 'Tại sao chọn chúng tôi?'
  content3a: any = "Viethas đảm bảo cung cấp cho khách hàng các sản phẩm uy tín, chất lượng cao, đáp ứng những tính năng mà khách hàng yêu cầu. Các sản phẩm với giá cả phải chăng, tối ưu tính năng theo nhu cầu sử dụng, giúp khách hàng tiết kiệm tối đa chi phí."
  content3b: any = " Thành công của chúng tôi chính là đạt được sự hài lòng và tin tưởng tuyệt đối của khách hàng. Hơn nữa, với phương châm “Khách hàng là thượng đế“, chúng tôi luôn cố gắng đạt được sự tín nhiệm không chỉ bằng chất lượng sản phẩm mà còn bởi dịch vụ chăm sóc khách hàng một cách tận tâm, hỗ trợ và giải đáp mọi thắc mắc của quý khách hàng một cách nhanh chóng."
}
